import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlowchartStore } from '../stores/flowchartStore';
import styles from './FlowchartNewPage.module.css';

export default function FlowchartNewPage() {
  const navigate = useNavigate();
  const { createFlowchart } = useFlowchartStore();
  
  const [title, setTitle] = useState('');
  const [folderPath, setFolderPath] = useState('/');
  const [isPrivate, setIsPrivate] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!title.trim()) {
      setError('Title is required');
      return;
    }

    setIsCreating(true);
    setError(null);

    try {
      const flowchart = await createFlowchart({
        title: title.trim(),
        folder_path: folderPath,
        is_private: isPrivate
      });
      
      navigate(`/flowcharts/edit/${flowchart.slug}`);
    } catch (err: any) {
      setError(err.message || 'Failed to create flowchart');
      setIsCreating(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Create New Flowchart</h1>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className={styles.error}>
              {error}
            </div>
          )}

          <div className={styles.formGroup}>
            <label className={styles.label}>Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter flowchart title"
              className={styles.input}
              autoFocus
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Folder Path</label>
            <input
              type="text"
              value={folderPath}
              onChange={(e) => setFolderPath(e.target.value)}
              placeholder="/"
              className={styles.input}
            />
            <p className={styles.helpText}>
              Use forward slashes (e.g., /guides/diagrams)
            </p>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={isPrivate}
                onChange={(e) => setIsPrivate(e.target.checked)}
                className={styles.checkbox}
              />
              <span className={styles.checkboxText}>
                Make this flowchart private (requires authentication to view)
              </span>
            </label>
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              onClick={() => navigate('/flowcharts')}
              className={styles.cancelButton}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isCreating}
              className={styles.submitButton}
            >
              {isCreating ? 'Creating...' : 'Create Flowchart'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
